import { useSelector } from 'react-redux';
import Workspace from 'src/entities/workspace';
import { getCurrentUserOwnWorkspace } from 'src/selectors/workspaces';

const useCurrentUserOwnsWorkspace = ( { workspaceID }: { workspaceID: number } ) => {
	const currentUserWorkspace: Workspace | undefined = useSelector( getCurrentUserOwnWorkspace );

	return currentUserWorkspace?.id === workspaceID;
};

export default useCurrentUserOwnsWorkspace;
